import { render, staticRenderFns } from "./WsRequestExamsFormOld.vue?vue&type=template&id=77f7ce4b&scoped=true"
import script from "./WsRequestExamsFormOld.vue?vue&type=script&lang=js"
export * from "./WsRequestExamsFormOld.vue?vue&type=script&lang=js"
import style0 from "./WsRequestExamsFormOld.vue?vue&type=style&index=0&id=77f7ce4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7ce4b",
  null
  
)

export default component.exports